import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Nav from '../components/Nav';
import Spinner from '../components/Spinner';

const BooksPage = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [hasBeenFetched, setHasBeenFetched] = useState<boolean>(false);
    const [content, setContent] = useState<string>("");
    const [lightboxOpen, setIsLightboxOpen] = useState<boolean>(false);
    const [lightboxImage, setLightboxImage] = useState<string>("");

    const getContent = async () => {
        setIsLoading(true);
        setHasBeenFetched(true);
        try {
            await axios.get('/content/books.html')
                .then(res => setContent(res.data))
                .catch(err => console.log(err));
        } catch (error) {
            console.log("Axios error");
            if (!axios.isCancel(error)) {
                // TODO error handling & error message
            }
        }
        setIsLoading(false);
    };

    useEffect(() => {
        if (!hasBeenFetched) {
            getContent();
        }
    }, []);

    const openImage = (Event: React.MouseEvent<HTMLAnchorElement>, ImageUrl: string) => {
        Event.preventDefault();
        setLightboxImage(ImageUrl);
        setIsLightboxOpen(true);
    };

    const closeImage = function () {
        setIsLightboxOpen(false);
    };

    return (
        <HelmetProvider>
            <Helmet>
                <title>Books | Pete Riski</title>
            </Helmet>

            <div className="site">
                <div className="container">
                    <Nav ActivePage="about-books" ActivePath="about" />
                    <div className="site-content">
                        {isLoading && (
                            <Spinner />
                        )}
                        {!isLoading && content !== "" &&
                            <div dangerouslySetInnerHTML={{ __html: content }} />
                        }
                        <div className="books-images-wrapper">
                            <a
                                className="book-1-image"
                                href="http://peteriski.com/wp-content/uploads/1/book-1.jpg"
                                onClick={(e) => openImage(e, "http://peteriski.com/wp-content/uploads/1/book-1.jpg")}
                            >
                                <img src="http://peteriski.com/wp-content/uploads/1/book-1.jpg" alt="" />
                            </a>
                            <a
                                className="book-1-image"
                                href="http://peteriski.com/wp-content/uploads/1/book-2.jpg"
                                onClick={(e) => openImage(e, "http://peteriski.com/wp-content/uploads/1/book-2.jpg")}
                            >
                                <img src="http://peteriski.com/wp-content/uploads/1/book-2.jpg" alt="" />
                            </a>
                            <a
                                className="book-1-image"
                                href="http://peteriski.com/wp-content/uploads/1/book-3.jpg"
                                onClick={(e) => openImage(e, "http://peteriski.com/wp-content/uploads/1/book-3.jpg")}
                            >
                                <img src="http://peteriski.com/wp-content/uploads/1/book-3.jpg" alt="" />
                            </a>
                            <a
                                className="book-1-image"
                                href="http://peteriski.com/wp-content/uploads/1/book-4.jpg"
                                onClick={(e) => openImage(e, "http://peteriski.com/wp-content/uploads/1/book-4.jpg")}
                            >
                                <img src="http://peteriski.com/wp-content/uploads/1/book-4.jpg" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            {(lightboxOpen && lightboxImage !== "") && (
                <div className="lightbox">
                    <div className="lightbox-outer lightbox-outer-image">
                        <div className="lightbox-inner lightbox-inner-image">
                            <div className="lightbox-image-wrapper">
                                <img src={lightboxImage} alt="" className="lightbox-image" />
                                <button
                                    className="lightbox-close lightbox-close-image"
                                    onClick={() => closeImage()}
                                >
                                    <span style={{ display: "none" }}>Sulje</span>
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L13 11.5858L23.2929 1.29289C23.6834 0.902369 24.3166 0.902369 24.7071 1.29289C25.0976 1.68342 25.0976 2.31658 24.7071 2.70711L14.4142 13L24.7071 23.2929C25.0976 23.6834 25.0976 24.3166 24.7071 24.7071C24.3166 25.0976 23.6834 25.0976 23.2929 24.7071L13 14.4142L2.70711 24.7071C2.31658 25.0976 1.68342 25.0976 1.29289 24.7071C0.90237 24.3166 0.90237 23.6834 1.29289 23.2929L11.5858 13L1.29289 2.70711Z" fill="white" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </HelmetProvider>
    );
};

export default BooksPage;